import { useTranslation } from 'react-i18next'
import { Text } from '@asus-common/fe-ui-shadcn'

import {
  AuthShell,
  LoginForm,
  RequestPasswordResetModalSlot,
} from '@/features/auth/components'

export function LoginPage() {
  const { t } = useTranslation('login')

  return (
    <AuthShell>
      <Text fontSize="2xl" fontWeight="bold">
        {t('title')}
      </Text>
      <LoginForm />
      <RequestPasswordResetModalSlot />
    </AuthShell>
  )
}
